// Static pricing tier configuration consumed by the Pricing page.
export const pricingTiers = [
  {
    name: "Launch",
    price: "90",
    ideal: "Ideal for: Startups & Sole Traders",
    color: "bg-green-500",
    popular: false,
    features: [
      "3 Website Pages",
      "Hosting Included",
      "Domain & Domain Protection",
      "Microsoft 365 Basic",
      "Website Maintenance",
      "2 Content Edits Included",
      "5 Edits Total Allowance",
      "3 Day First Response",
      "5 Day SLA Closure",
      "Standard Security",
    ],
    notIncluded: ["SEO", "Priority Support", "Booking Integration", "CRM Automation"],
  },
  {
    name: "Grow",
    price: "125",
    ideal: "Ideal for: Small Businesses Scaling",
    color: "bg-blue-500",
    popular: false,
    features: [
      "5 Website Pages",
      "Hosting Included",
      "Domain & Domain Protection",
      "Microsoft 365 Standard",
      "Website Maintenance",
      "4 Content Edits Included",
      "8 Edits Total Allowance",
      "2 Day First Response",
      "3 Day SLA Closure",
      "Standard Security",
      "Basic SEO Setup",
    ],
    notIncluded: [],
  },
  {
    name: "Scale",
    price: "200",
    ideal: "Ideal for: Established Businesses",
    color: "bg-purple-500",
    popular: true,
    features: [
      "10 Website Pages",
      "Hosting Included",
      "Domain & Domain Protection",
      "Microsoft 365 Professional",
      "Website Maintenance",
      "7 Content Edits Included",
      "12 Edits Total Allowance",
      "1 Day First Response",
      "2 Day SLA Closure",
      "Priority Support Included",
      "24/5 Support",
      "Enhanced Security",
      "Basic SEO Setup",
    ],
    notIncluded: [],
  },
  {
    name: "Dominate",
    price: "325",
    ideal: "Ideal for: Premium Businesses",
    color: "bg-red-500",
    popular: false,
    features: [
      "15 Website Pages",
      "Hosting Included",
      "Domain & Domain Protection",
      "Microsoft 365 Premium",
      "Website Maintenance",
      "9 Content Edits Included",
      "17 Edits Total Allowance",
      "8 Hour First Response",
      "1 Day SLA Closure",
      "24/7 Support",
      "Priority Support Included",
      "Enhanced Security Monitoring",
      "Basic SEO Setup",
    ],
    notIncluded: [],
  },
];

export const pricingFaqs = [
  {
    q: "What's included in website maintenance?",
    a: "Website maintenance includes regular security updates, software patches, uptime monitoring, and ensuring your site runs smoothly. We also handle any technical issues that arise.",
  },
  {
    q: "What counts as a content edit?",
    a: "A content edit includes things like updating text, swapping images, changing contact details, or minor layout adjustments. More complex changes like adding new sections or features may count as additional edits.",
  },
  {
    q: "Can I upgrade my plan later?",
    a: "Absolutely! You can upgrade your plan at any time. We'll simply adjust your monthly rate and add any additional features or pages to your existing website.",
  },
  {
    q: "What's the difference between Standard and Enhanced Security?",
    a: "Standard Security includes SSL certificates, regular updates, and basic firewall protection. Enhanced Security adds advanced monitoring, malware scanning, and priority response to any security concerns.",
  },
  {
    q: "What if I need more pages than my plan includes?",
    a: "No problem! You can add extra pages at any time for £60 per page (one-off cost). Alternatively, if you find you regularly need more, we can discuss upgrading to a higher tier.",
  },
  {
    q: "What Microsoft 365 features are included?",
    a: "Each tier includes different Microsoft 365 plans with professional email, cloud storage, and productivity tools. Higher tiers include more storage, advanced features, and additional apps like Teams and SharePoint.",
  },
  {
    q: "How long does it take to build my website?",
    a: "Most websites are completed within 2-4 weeks depending on the number of pages and complexity. We'll give you a clear timeline during our initial consultation.",
  },
  {
    q: "What happens if I want to cancel?",
    a: "You can cancel anytime with 30 days notice. We'll help transfer your domain and provide any files you need. There are no long-term contracts or cancellation fees.",
  },
];

export const addOnGroups = [
  {
    title: "Advanced SEO",
    items: [
      { label: "Setup", value: "£200" },
      { label: "Local SEO", value: "£150/month" },
      { label: "Growth SEO", value: "£250/month" },
      { label: "Aggressive SEO", value: "£350/month" },
    ],
  },
  {
    title: "Booking & CRM",
    items: [
      { label: "Basic Booking Setup", value: "£250" },
      { label: "Advanced CRM", value: "£450–£650" },
    ],
  },
  {
    title: "Branding",
    items: [
      { label: "Starter Logo", value: "£250" },
      { label: "Full Branding Kit", value: "£450–£750" },
    ],
  },
  {
    title: "Extras",
    items: [
      { label: "Extra Pages", value: "£60 each" },
      { label: "Content Updates", value: "£45/30 mins" },
      { label: "5 Edits Bundle", value: "£75" },
      { label: "Priority Support", value: "£50/month" },
    ],
  },
];
